import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgOrganizationRound = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="70"
        viewBox="0 0 70 70"
        width="70"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_10604_5234)">
            <rect fill="#DBD6FF" height="70" rx="35" width="70" />
            <path
                d="M14.4237 32.6024H0V69.8094H14.4237V32.6024Z"
                fill="#F8F8F8"
            />
            <path
                d="M11.7069 58.1461H2.71722V60.4925H11.7069V58.1461Z"
                fill="#DAD7D7"
            />
            <path
                d="M11.7069 53.8894H2.71722V56.2358H11.7069V53.8894Z"
                fill="#DAD7D7"
            />
            <path
                d="M11.7069 49.6323H2.71722V51.9787H11.7069V49.6323Z"
                fill="#DAD7D7"
            />
            <path
                d="M11.7069 45.3739H2.71722V47.7203H11.7069V45.3739Z"
                fill="#DAD7D7"
            />
            <path
                d="M11.7069 41.1176H2.71722V43.464H11.7069V41.1176Z"
                fill="#DAD7D7"
            />
            <path
                d="M11.7069 36.8611H2.71722V39.2075H11.7069V36.8611Z"
                fill="#DAD7D7"
            />
            <path
                d="M24.901 32.6021L19.9487 27.2612L14.4239 32.6021V69.8092H24.901V32.6021Z"
                fill="#EDEBEB"
            />
            <path
                d="M22.8684 58.1461H17.4193V60.493H22.8684V58.1461Z"
                fill="#715AFF"
            />
            <path
                d="M22.8684 53.8894H17.4193V56.2362H22.8684V53.8894Z"
                fill="#715AFF"
            />
            <path
                d="M11.7069 62.3564H2.71722V64.7028H11.7069V62.3564Z"
                fill="#EDEBEB"
            />
            <path
                d="M22.8684 62.3564H17.4193V64.7032H22.8684V62.3564Z"
                fill="#715AFF"
            />
            <path
                d="M22.8684 49.6323H17.4193V51.9792H22.8684V49.6323Z"
                fill="#715AFF"
            />
            <path
                d="M22.8684 45.3739H17.4193V47.7207H22.8684V45.3739Z"
                fill="#715AFF"
            />
            <path
                d="M22.8684 41.1176H17.4193V43.4644H22.8684V41.1176Z"
                fill="#715AFF"
            />
            <path
                d="M22.8684 36.8611H17.4193V39.208H22.8684V36.8611Z"
                fill="#715AFF"
            />
            <path
                d="M19.949 27.2614H5.52528L0.000488281 32.6023H14.4242L19.949 27.2614Z"
                fill="#302B63"
            />
            <path
                d="M38.6803 69.8091H38.771V21.5364H38.6944L30.5049 13.4169L22.5473 21.5364V69.8091H38.6803Z"
                fill="white"
            />
            <path
                d="M59.2633 21.5364L51.0759 13.4169H30.5066L38.7726 21.5364H59.2633Z"
                fill="#302B63"
            />
            <path
                d="M38.7726 21.5364L30.5066 13.4169L38.696 21.5364H38.7726Z"
                fill="#302B63"
            />
            <path
                d="M59.1925 21.5362H38.7723V69.8089H59.1925V21.5362Z"
                fill="#BEB3FF"
            />
            <path
                d="M30.2453 32.4494C30.2453 32.4494 30.5981 32.4494 32.0456 30.6095C33.493 28.7696 33.0515 27.3317 32.0456 27.0307C31.0597 26.7379 30.2453 28.0103 30.2453 28.0103C30.2453 28.0103 29.4308 26.7379 28.445 27.0307C27.439 27.3296 26.9975 28.7676 28.445 30.6095C29.8925 32.4494 30.2453 32.4494 30.2453 32.4494Z"
                fill="#FED05D"
            />
            <path
                d="M47.3457 26.9861H43.1451V35.3964H47.3457V26.9861Z"
                fill="#715AFF"
            />
            <path
                d="M54.8158 26.9861H50.6153V35.3964H54.8158V26.9861Z"
                fill="#715AFF"
            />
            <path
                d="M47.3457 38.4576H43.1451V46.8679H47.3457V38.4576Z"
                fill="#715AFF"
            />
            <path
                d="M54.8158 38.4579H50.6153V46.8681H54.8158V38.4579Z"
                fill="#715AFF"
            />
            <path
                d="M47.3457 49.9294H43.1451V58.3396H47.3457V49.9294Z"
                fill="#715AFF"
            />
            <path
                d="M54.8158 49.9294H50.6153V58.3396H54.8158V49.9294Z"
                fill="#715AFF"
            />
            <path
                d="M47.3457 61.4007H43.1451V69.811H47.3457V61.4007Z"
                fill="#715AFF"
            />
            <path
                d="M54.8158 61.4007H50.6153V69.811H54.8158V61.4007Z"
                fill="#715AFF"
            />
            <path
                d="M67.6378 38.4578H50.616V69.809H67.6378V38.4578Z"
                fill="#F8F8F8"
            />
            <path
                d="M65.4243 58.1458H52.8307V60.4921H65.4243V58.1458Z"
                fill="#DAD7D7"
            />
            <path
                d="M65.4243 53.8891H52.8307V56.2355H65.4243V53.8891Z"
                fill="#DAD7D7"
            />
            <path
                d="M65.4243 49.6326H52.8307V51.979H65.4243V49.6326Z"
                fill="#DAD7D7"
            />
            <path
                d="M65.4243 45.374H52.8307V47.7204H65.4243V45.374Z"
                fill="#DAD7D7"
            />
            <path
                d="M65.4243 41.1172H52.8307V43.4636H65.4243V41.1172Z"
                fill="#DAD7D7"
            />
            <path
                d="M75.7931 38.4578H67.6399V69.809H75.7931V38.4578Z"
                fill="#DAD7D7"
            />
            <path
                d="M73.7602 58.1458H69.6718V60.4926H73.7602V58.1458Z"
                fill="#3E82C2"
            />
            <path
                d="M73.7602 53.8891H69.6718V56.2359H73.7602V53.8891Z"
                fill="#3E82C2"
            />
            <path
                d="M65.4243 62.3556H52.8307V64.702H65.4243V62.3556Z"
                fill="#DAD7D7"
            />
            <path
                d="M73.7602 62.3556H69.6718V64.7024H73.7602V62.3556Z"
                fill="#3E82C2"
            />
            <path
                d="M73.7602 49.6326H69.6718V51.9794H73.7602V49.6326Z"
                fill="#3E82C2"
            />
            <path
                d="M73.7602 45.374H69.6718V47.7208H73.7602V45.374Z"
                fill="#3E82C2"
            />
            <path
                d="M73.7602 41.1175H69.6718V43.4643H73.7602V41.1175Z"
                fill="#3E82C2"
            />
        </g>
        <defs>
            <clipPath id="clip0_10604_5234">
                <rect fill="white" height="70" rx="35" width="70" />
            </clipPath>
        </defs>
    </svg>
);

export const OrganizationRoundIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgOrganizationRound}
        fontSize={fontSize}
    />
);
